import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
//InvitaTion
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import( '../views/HomeContent.vue'),
    children:[
      {
        path: '/homearr',
        name: 'homearr',
        meta:{
          title:"口袋饭票"
        },
        component: () => import( '../views/HomeView.vue')
      },
      {
        path: '/about',
        name: 'about',
        meta:{
          title:"口袋饭票"
        },
        component: () => import( '../views/HomeAbout.vue')
      },
      {
        path: '/',
        name: 'bwc',
        meta:{
          title:"口袋饭票"
        },
        component: () => import( '../views/HomeBwc.vue')
      },
      {
        path: '/koudai',
        name: 'koudai',
        meta:{
          title:"口袋饭票"
        },
        component: () => import( '../views/HomeBwcs.vue')
      },
      {
        path: '/CommAnder',
        name: 'CommAnder',
        meta:{
          title:"口袋饭票"
        },
        component: () => import( '../views/CommAnder.vue')
      }
    ]
  },
  {
    path: '/InvitaTion',
    name: 'InvitaTion',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/InvitaTion.vue')
  },
  {
    path: '/BwcStrategy',
    name: 'BwcStrategy',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/HomeGlues.vue')
  },
  {
    path: '/RecordList',
    name: 'RecordList',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/RecordList.vue')
  },
  {
    path: '/IntroduCtion',
    name: 'IntroduCtion',
    meta:{
      title:"省钱攻略"
    },
    component: () => import( '../views/IntroduCtion.vue')
  },
  {
    path: '/myorder',
    name: 'myorder',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/MyOrder.vue')
  },
  {
    path: '/WithDrawal',
    name: 'WithDrawal',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/WithDrawal.vue')
  },
  {
    path: '/DrawalDetails',
    name: 'DrawalDetails',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/DrawalDetails.vue')
  },
  {
    path: '/LocationIndex',
    name: 'LocationIndex',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/LocationIndex.vue')
  },
  {
    path: '/HomeGlues',
    name: 'HomeGlues',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/HomeGlues.vue')
  },
  {
    path: '/MyBanner',
    name: 'MyBanner',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/MyBanner.vue')
  },
  {
    path: '/ListMoney',
    name: 'ListMoney',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/ListMoney.vue')
  },
  {
    path: '/GoQrcode',
    name: 'GoQrcode',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/GoShare.vue')
  },
  {
    path: '/GoShare',
    name: 'GoShare',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/GoQrcode.vue')
  },
  {
    path: '/DoubleOne',
    name: 'DoubleOne',
    meta:{
      title:"双十一超级红包天天领"
    },
    component: () => import( '../views/DoubleOne.vue')
  },
  {
    path: '/OrderList',
    name: 'OrderList',
    meta:{
      title:"口袋饭票"
    },
    component: () => import( '../views/OrderList.vue')
  },
  {
    path: '/LikeS',
    name: 'LikeS',
    meta:{
      title:"提交订单号与截图"
    },
    component: () => import( '../views/LikeS.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = String(to.meta.title);
  }
  next()
  })
export default router
